import { RepeatableField, Section, SectionField } from "types/Models/Filing";

export const getFieldsFromSections = (
  sections: Section[] | undefined
): SectionField[] =>
  (sections ?? []).flatMap((section) => [
    ...(section.section_fields ?? []),
    ...(section.repeatable_fields ?? []).flatMap(
      (repeatable: RepeatableField) => repeatable.fields ?? []
    ),
  ]);
